import { useEffect, useState } from "react";
import { toast } from "sonner";
import { api, errMsg, rupiah } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { useAuth } from "@/context/Auth";
import { MaintenancePanel } from "@/components/MaintenancePanel";

export default function Settings() {
  const { isAdmin } = useAuth();
  const [ops, setOps] = useState([]);
  const [low, setLow] = useState(5000);
  const [lim, setLim] = useState(1000000);
  const [ready, setReady] = useState(false);
  useEffect(() => {
    api.get("/settings").then((r) => { setOps(r.data.operators || []); setLow(r.data.low_balance ?? 5000); setLim(r.data.topup_limit ?? 1000000); setReady(true); });
  }, []);
  const save = async () => {
    try {
      await api.put("/settings", { operators: ops, low_balance: Number(low), topup_limit: Number(lim) });
      toast.success("Pengaturan disimpan");
    } catch (e) {
      toast.error(errMsg(e));
    }
  };
  return (
    <div className="max-w-2xl space-y-5">
      {isAdmin && <MaintenancePanel />}
      <div>
        <p className="text-xs uppercase tracking-wider text-slate-500">Admin</p>
        <h1 className="font-display text-4xl font-bold">Kode cek pulsa</h1>
        <p className="text-sm text-slate-500 mt-1">Dipakai saat tombol "Cek pulsa" atau "Cek semua saldo" ditekan (tidak otomatis).</p>
      </div>
      <div className="rounded-lg border border-slate-200 bg-white divide-y divide-slate-200">
        {ops.map((o, i) => (
          <div key={o.key} className="flex items-center gap-4 p-4">
            <span className="flex-1 font-semibold">{o.name}</span>
            <Input data-testid={`operator-code-${o.key}`} value={o.ussd} onChange={(e) => setOps(ops.map((x, j) => (j === i ? { ...x, ussd: e.target.value } : x)))} className="w-40 bg-white font-mono" />
          </div>
        ))}
      </div>
      <div className="rounded-lg border border-slate-200 bg-white p-4 flex items-center gap-4">
        <span className="flex-1">Batas pulsa rendah <span className="text-xs text-slate-500">(ditandai kuning · {rupiah(low)})</span></span>
        <Input data-testid="low-balance-input" type="number" value={low} onChange={(e) => setLow(e.target.value)} className="w-40 bg-white font-mono" />
      </div>
      <div className="rounded-lg border border-slate-200 bg-white p-4 flex items-center gap-4">
        <span className="flex-1">Limit pulsa masuk per SIM per hari <span className="text-xs text-slate-500">(kuning ≥80%, merah LIMIT · reset 00:00 WIB · {rupiah(lim)})</span></span>
        <Input data-testid="topup-limit-input" type="number" value={lim} onChange={(e) => setLim(e.target.value)} className="w-40 bg-white font-mono" />
      </div>
      <Button data-testid="settings-save-button" onClick={save} disabled={!ready} className="bg-emerald-500 hover:bg-emerald-600 text-white">Simpan</Button>

    </div>
  );
}
